import { css } from "@stubhub/broadway-foundation/css";
import { Feature } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import { AlternativePerformerGridLoadingSkeleton } from "src/website-apps/responsive/stubhub-performer/components/performer-carousel-skeleton/AlternativePerformerGridLoadingSkeleton";
import { usePerformerCarouselLayout } from "src/website-apps/responsive/stubhub-performer/components/performer-carousel-skeleton/usePerformerCarouselLayout";
import {
  SignInBannerLoadingSkeleton,
  SignInBannerSkeleton,
} from "src/website-apps/responsive/stubhub-performer/components/performer-sign-in-banner/styled-components";
import { LoadingCarousel } from "src/website-apps/shared/components/LoadingCarousel";

const carouselContainerStyles = css({ marginBlockStart: "primitives.300" });

const SignInBannerSkeletonFeature = () => (
  <Feature
    id={FeatureSetEnum.TMGlobalDSSkeleton}
    control={() => <SignInBannerLoadingSkeleton />}
    variant={() => <SignInBannerSkeleton />}
  />
);

/**
 * Loading skeleton to show on the performer page for the carousel section. Displays multiple loading skeletons for each carousel.
 */
export const PerformerLoadingCarousels = () => {
  const { signInBannerPosition, carousels: carouselLayouts } = usePerformerCarouselLayout();
  return (
    <>
      {carouselLayouts.map((carouselLayout, i) =>
        signInBannerPosition === i ? (
          <SignInBannerSkeletonFeature key="sign-in" />
        ) : (
          <div className={carouselContainerStyles} key={carouselLayout.key}>
            {carouselLayout.isGridLayout ? (
              <AlternativePerformerGridLoadingSkeleton count={carouselLayout.count ?? 0} />
            ) : (
              <LoadingCarousel
                count={carouselLayout.pageSize}
                size={carouselLayout.imageSize}
                placeHolderLineCount={carouselLayout.placeHolderLineCount}
                overrideTitleHeight={38}
              />
            )}
          </div>
        ),
      )}
    </>
  );
};
